import React from 'react';
import {
  RouteConfig,
  RouteConfigMap
} from 'navigation/router/route-switch/_utils/route-config-map';
import { CartProvider } from './context-cart';
import { BillingBuyBulkPage } from './page-billing-buy-bulk';
import { BillingBuyPPUPage } from './page-billing-buy-ppu';
import { BillingCheckoutPage } from './page-billing-checkout';
import { ClinicRoutes } from 'routes';
import { Role } from 'features/auth/types';
import { useAuth } from 'lib/hooks/auth/use-auth';
import { useGetPrincipalUser } from 'lib/hooks/tanstack/use-getClinicInfo';
import { useClinicianContext } from 'lib/hooks/use-resolveCurrentClinicInfo';
import { Text } from 'components/mvp-typography';
import { BillingSettingsPage } from './page-billing-settings';
import { BillingSubscriptionPage } from './page-billing-subscription';
import { BillingOrganisationUsagePage } from './page-billing-organisation-usage';

export const BillingContainer: React.FC = () => {
  const { user } = useAuth();
  const { currentClinic } = useClinicianContext();
  const principalUserQuery = useGetPrincipalUser(currentClinic);

  const isPrincipalUser =
    user?.uid && principalUserQuery.data?.data?.uid === user.uid;

  const billingRoutesConfig: RouteConfig[] = [
    {
      type: 'private',
      path: ClinicRoutes.ClinicBuyBulk,
      roles: [Role.ClinicAdmin, Role.Clinician],
      component: BillingBuyBulkPage
    },
    {
      type: 'private',
      path: ClinicRoutes.ClinicPayAsYouGo,
      roles: [Role.ClinicAdmin, Role.Clinician],
      component: BillingBuyPPUPage
    },
    {
      type: 'private',
      path: ClinicRoutes.ClinicCheckout,
      roles: [Role.ClinicAdmin, Role.Clinician],
      component: BillingCheckoutPage
    },
    {
      type: 'private',
      path: ClinicRoutes.ClinicBillingSettings,
      roles: [Role.ClinicAdmin, Role.Clinician],
      component: isPrincipalUser ? BillingSettingsPage : () => <Text>Only the Principal User can access billing settings.</Text>
    },
    {
      type: 'private',
      path: ClinicRoutes.ClinicBillingSubscription,
      roles: [Role.ClinicAdmin, Role.Clinician],
      component: BillingSubscriptionPage
    },
    {
      type: 'private',
      path: ClinicRoutes.ClinicBillingOrganisationUsage,
      roles: [Role.ClinicAdmin, Role.Clinician],
      component: BillingOrganisationUsagePage
    }
  ];

  if (principalUserQuery.isLoading) {
    return <Text>Loading billing information...</Text>;
  }

  return (
    <CartProvider>
      <RouteConfigMap isSwitch routeConfig={billingRoutesConfig} />
    </CartProvider>
  );
};
